import { Scene } from "phaser";

export default class Settings extends Scene {

    constructor() {
        super({ key: "Settings" });
    }

    init(data) {
        this.previousScene = data.scene;
    }

    preload() {
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {
        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 6;

        const w = this.textures.get('backgroundSettings').getSourceImage().width;
        const h = this.textures.get('backgroundSettings').getSourceImage().height;

        let scaleX = this.cameras.main.width / w;
        let scaleY = this.cameras.main.height / h;
        let scale1 = Math.max(scaleX, scaleY)
        this.imageBackground = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, `backgroundSettings`).setScale(scale1).setScrollFactor(0);

        this.image = this.add.image(0, 0,'backgroundPause').setOrigin(0.5).setAlpha(0.7).setScale(2);

        // this.image.width = 800;
        // this.image.height = 500;

        this.gameSettings = JSON.parse(localStorage.getItem('myGameSettings'));

        this.add.text(screenCenterX, screenCenterY, `SETTINGS`, { font: "46px CustomFont", fill: "#FFFFFF", stroke: "#F2C763", strokeThickness: 3 }).setOrigin(0.5);
        this.add.text(screenCenterX, screenCenterY + 100, `SOUND EFFECTS`, { font: "18px CustomFont", fill: "#FFFFFF", stroke: "#F2C763", strokeThickness: 3 }).setOrigin(0.5);
        this.textSoundeffects = this.add.text(screenCenterX + 200, screenCenterY + 100, this.gameSettings[1]
            .value === true ? 'ON' : 'OFF', { font: "12px CustomFont", fill: "#FFFFFF", stroke: "#F2C763", strokeThickness: 3 }).setOrigin(0.5).setInteractive({ useHandCursor: true })
        .on('pointerdown', () => {
            

                this.textSoundeffects.setTint(0x8A2A2B);

               
        })
        .on('pointerup', () => {
            this.textSoundeffects.setTint(0xFFFFFF)

            if (this.gameSettings[1].value) {
                this.gameSettings[1].value = false;
                this.textSoundeffects.text = 'OFF';
              } else {
                this.gameSettings[1].value = true;
                this.textSoundeffects.text = 'ON';
              }
              localStorage.setItem('myGameSettings', 
                JSON.stringify(this.gameSettings));


        });
        this.add.text(screenCenterX, screenCenterY + 200, `MUSIC`, { font: "18px CustomFont", fill: "#FFFFFF", stroke: "#F2C763", strokeThickness: 3 }).setOrigin(0.5);
        this.textMusic = this.add.text(screenCenterX + 200, screenCenterY + 200, this.gameSettings[0]
            .value === true ? 'ON' : 'OFF', { font: "12px CustomFont", fill: "#FFFFFF", stroke: "#F2C763", strokeThickness: 3 }).setOrigin(0.5).setInteractive({ useHandCursor: true })
        .on('pointerdown', () => {
            this.textMusic.setTint(0x8A2A2B);

            
        })
        .on('pointerup', () => {
            this.textMusic.setTint(0xFFFFFF)

            if (this.gameSettings[0].value) {
                this.gameSettings[0].value = false;
                this.textMusic.text = 'OFF';
              } else {
                this.gameSettings[0].value = true;
                this.textMusic.text = 'ON';
              }
              localStorage.setItem('myGameSettings', 
                JSON.stringify(this.gameSettings));
        });

        this.buttonQuit = this.add.text(screenCenterX, screenCenterY+ 300, `CLOSE`, { font: "15px CustomFont", fill: "#FFFFFF", stroke: "#F2C763", strokeThickness: 3 }).setOrigin(0.5).setInteractive({ useHandCursor: true })
        .on('pointerdown', () => {
            this.scene.wake(this.previousScene);this.scene.stop();
        });

    }

    
    update() {


    }


}